import logo from '../assets/logo.svg';
import styled from 'styled-components';
import { Colors } from '../constants/colors';
import { ExitToApp } from '@material-ui/icons';
import React from 'react';
import { Device } from '../constants/device';
import { Button } from './buttons/Button';
import { Sizes } from '../constants/sizes';
import { useDispatch } from 'react-redux';
import { logOut } from '../store/auth/actions/logOut';
import { Link, useNavigate } from 'react-router-dom';

type HeaderProps = {
  showLogout?: boolean
}

export const Header = (props: HeaderProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogOut = async () => {
    await dispatch(logOut());
    navigate('/login', { replace: true });
  };

  return <StyledHeader>
    <Logo to='/'>
      <img src={logo} alt='IKEM logo' />
      <div>Online<br />Connect</div>
    </Logo>
    <h1>Systém evidence žádostí IKEM</h1>
    {props.showLogout === true && <div className='button'>
      <Button onClick={handleLogOut} compact>
        Odhlásit
        <ExitToApp />
      </Button>
    </div>}
  </StyledHeader>;
};

const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: ${Sizes.HeaderHeight}px;
  margin-bottom: 30px;

  ${Device.downTablet} {
    height: auto;
    flex-direction: column;
    align-items: flex-start;
  }

  .button {
    padding: 0 30px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;

    ${Device.downTablet} {
      padding: 30px 15px 0;
    }
  }

  h1 {
    flex: 1;
    margin: 0 0 0 30px;
    color: ${Colors.primaryDarker};

    ${Device.downTablet} {
      margin: 30px 15px 0;
    }
  }
`;

export const Logo = styled(Link)`
  display: flex;
  align-items: center;
  background: ${Colors.white};
  padding: 10px 40px 10px 30px;
  height: 100%;
  border-radius: 0 0 40px 0;
  box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
  text-decoration: none;

  img {
    height: 40px;
  }

  div {
    font-size: 18px;
    font-weight: 600;
    position: relative;
    line-height: 1;
    color: ${Colors.primary};
    padding-left: 32px;

    &:before {
      content: '';
      width: 3px;
      background: ${Colors.primary};
      height: 30px;
      margin: 5px 15px;
      display: block;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
`;

